import { render, staticRenderFns } from "./DeviceResellers.vue?vue&type=template&id=ff5bfc74"
import script from "./DeviceResellers.vue?vue&type=script&lang=js"
export * from "./DeviceResellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports